export default {
    navigationBarTitleText: '部件编辑专题',
    navigationBarBackgroundColor: "#DF773C",
};
